import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, message } from 'antd';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { RulingApplication } from '../CaseDetails/CaseDetails';


const RulingApplications = () => {
  const [data, setData] = useState<RulingApplication[]>([]);
  // const [mockTableData, setMockTableData] = useState<RulingApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<RulingApplication | null>(null);
  const navigate = useNavigate();

  const authToken = sessionStorage.getItem('token');

  useEffect(() => {
    const fetchRulingApplications = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://backend-kyw8.onrender.com/court-records/judge', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const jsonData = await response.json();
        const rulingApplications = jsonData.applications.filter(
          (app: RulingApplication) => app.applicationType === 'RULING'
        );
        setData(rulingApplications);
        console.log(rulingApplications);
      } catch (error) {
        setError(error as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchRulingApplications();
  }, [authToken]);

  const handlereject = async (applicationId: string | undefined) => {
    const approved = false;
    try {
      const response = await fetch(`"https://backend-kyw8.onrender.com/court-records"`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
            applicationId,
            approved
        })
      });
      const data = await response.json();
      console.log(data);
      if (!response.ok) {
        throw new Error(data.error ?? 'An error occurred');
      }
      message.success('Application rejected successfully');
      handleModalClose();
      return data;
    } catch (error) {
      console.error('Error:', error);
    }
  }


  
  const showModal = (record: RulingApplication) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  const showConfirmationModal = (action: 'approve' | 'reject') => {
    Modal.confirm({
      title: `Are you sure you want to ${action} this application?`,
      content: `This action will ${action} the ruling application.`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        // Handle the approve or reject action here
        message.success(`Application ${action}ed successfully`);
  
        // Navigate only on approve
        if (action === 'approve') {
          navigate(`/dashboard/upload-ruling/${selectedRecord?.caseId}/${selectedRecord?.applicationType}/${selectedRecord?.id}`);
        }
        if (action === 'reject') {
          handlereject(selectedRecord?.id);
        }
      },
    });
  };

  const columns = [
    {
      title: 'Suit NO',
      dataIndex: ['case', 'suitNumber'], // Updated to access nested case.suitNumber
      key: 'suitNumber',
    },
    {
      title: 'Digital Seal',
      dataIndex: 'digitalSeal',
      key: 'digitalSeal',
      render: (text: string) => (
        <a href={text} target="_blank" rel="noopener noreferrer" className='hover:text-[#9B111E]'>
          View Seal
        </a>
      ),
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      key: 'signature',
      render: (text: string) => (
        <a href={text} target="_blank" rel="noopener noreferrer" className='hover:text-[#9B111E]'>
          View Signature
        </a>
      ),
    },
    {
      title: 'Approval Document',
      dataIndex: 'approvalDocument',
      key: 'approvalDocument',
      render: (documents: string[]) =>
        documents.length > 0 ? (
          documents.map((doc, index) => (
            <div key={index}>
              <a href={doc} target="_blank" rel="noopener noreferrer" className='hover:text-[#9B111E]'>
                View Document {index + 1}
              </a>
            </div>
          ))
        ) : (
          <span>Not Available</span>
        ),
    },
    {
      title: 'Go to case',
      key: 'actions',
      render: (record: RulingApplication) => (
        <Link to={`/dashboard/case-details/${record.caseId}`}>
          <Button type="primary" className="bg-brown !hover:bg-[#9B111E]">View Case</Button>
        </Link>
      ),
    },
    {
      title: 'Approve/Reject',
      key: 'modalAction',
      render: (record: RulingApplication) => {
        if (record.approved) {
          return <span><strong>Approved</strong></span>;
        }
        //  else if (!record.approved) {
        //   return <span><strong>Rejected</strong></span>;
        else {
          return (
            <Button
              type="primary"
              className="bg-brown hover:bg-lightBrown"
              onClick={() => showModal(record)}
            >
              Approve/Reject
            </Button>
          );
        }
      },
    },
  ];

  const TablePaginationConfig = {
    pageSize: 10, 
    showSizeChanger: false,
    showTotal: (total) => `Total ${total} items`, 
    
  };

  // const generateMockData = (numRecords: number): RulingApplication[] => {
  //   const mockData: RulingApplication[] = []; // Specify the type

  //   for (let i = 0; i < numRecords; i++) {
  //     const approved = Math.random() > 0.5; // Randomly set approval status

  //     mockData.push({
  //       caseId: `CASE-${i + 1}`,
  //       case: {
  //         suitNumber: `SUIT-${i + 1}`,
  //       },
  //       digitalSeal: `https://example.com/digital-seal/${i + 1}.png`,
  //       signature: `https://example.com/signature/${i + 1}.png`,
  //       approvalDocument: [
  //         `https://example.com/document-${i + 1}-1.pdf`,
  //         `https://example.com/document-${i + 1}-2.pdf`,
  //       ],
  //       approved: approved,
  //       applicationType: 'RULING',
  //       id: `RULING-${i + 1}`,
  //     });
  //   }

  //   return mockData;
  // };

  // // Set mock data when component mounts
  // useEffect(() => {
  //   const data = generateMockData(20);
  //   setMockTableData(data);
  // }, []);
  
  return (
    <div className="custom-scrollable-table">
      <p className='form-header'>Ruling Applications</p>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="caseId"
        loading={loading}
        pagination={TablePaginationConfig}
        className="custom-table ant-table"
      />
      {error && <p>Error: {error.message}</p>}

      {/* Modal */}
      <Modal
        title="Ruling Application Details"
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button key="close" onClick={handleModalClose}>
            Close
          </Button>,
          <Button key="approve" type="primary" onClick={() => showConfirmationModal('approve')}>
            Approve
          </Button>,
          <Button key="reject" type="primary" danger onClick={() => showConfirmationModal('reject')}>
            Reject
          </Button>,
        ]}
      >
        {selectedRecord ? (
          <div>
            <p><strong>Suit NO:</strong> {selectedRecord.case.suitNumber}</p>
            <p><strong>Application Reason:</strong> {selectedRecord.applicationReason}</p>
            {/* Add more details as needed */}
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </div>
  );
};

export default RulingApplications;
